const header = () => {
    const headerSearch = document.querySelector('.header__search');
    const headerSearchbar = document.querySelector('.header__searchbar');
    const headerLogo = document.querySelector('.header__logo');
    const headerMenu = document.querySelector('.header__menu');
    const headerControls = document.querySelector('.header__controls');
    const headerBurger = document.querySelector('.header__burger');

    const headerSearchHandler = (e) => {
        e.preventDefault();

        if (headerSearchbar) {
            headerSearchbar.classList.toggle('header__hide');
        }
        if (headerLogo) {
            headerLogo.classList.toggle('header__hide');
        }
        if (headerMenu) {
            headerMenu.classList.toggle('header__hide');
        }
        if (headerControls) {
            headerControls.classList.toggle('header__hide');
        }
    };

    const headerBurgerHandler = (e) => {
        e.preventDefault();

        if (headerBurger) {
            headerBurger.classList.toggle('header__burger--active');
        }

        if(headerSearchbar) {
            headerSearchbar.classList.toggle("header__searchbar--block");
            
        }

        $('.header__menu__mobile').slideToggle('visible');
    };

    if (headerSearch) {
        headerSearch.addEventListener('click', headerSearchHandler);
    }

    if (headerBurger) {
        headerBurger.addEventListener('click', headerBurgerHandler);
    }
}

export default header;